import type {ReactAction} from '@netx/core/bootstrap';
import {faInbox} from '@netx/core-icons';
import {CartsSavedLabel} from '../locales';

export const cartsSavedActionRouteIcon = faInbox;

/**
 * Goto saved carts
 * @param params
 * @returns Action
 */
export const cartsSavedActionRoute = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'carts-saved-route',
	cb: () => dispatcher.trigger('nx:collections'),
	icon: cartsSavedActionRouteIcon,
	get label() {
		return CartsSavedLabel.ROUTE;
	},
	routeMatch: /cart-assets|cart\/saved/,
	...params,
});

export default cartsSavedActionRoute;
